<template>
    <!-- 编辑模态框 -->
    <el-dialog title="上传附件" :visible.sync="dialogVisible" top="20px" :append-to-body="appendToBody" @close="handleClose">
      <upload-file ref="upload"
                   @uploaded="handleUploaded"
                   @appended="handleAppended"
                   v-bind="$attrs"
      ></upload-file>
      <!-- 按钮组 -->
      <div class="pt-4 clearfix">
        <span class="float-right">
          <el-button size="small" type="default" @click="handleClose">关闭</el-button>
          <el-button size="small" type="primary" @click="handleUpload">上传</el-button>
        </span>
      </div>
    </el-dialog>
  </template>
  
  <script>
    /* eslint-disable */
    import UploadFile from './upload-file'
  
    export default {
      name: 'upload-dialog',
      components: {
        UploadFile
      },
      props: {
        appendToBody: {
          type: Boolean,
          default: false,
          required: false
        }
      },
      data() {
        return {
          dialogVisible: false,
        }
      },
      methods: {
        handleOpen() {
          this.dialogVisible = true
        },
        handleUpload() {
          this.$refs.upload.handleUpload()
        },
        handleAppended(fileList) {
          this.$emit('appended', fileList);
          this.dialogVisible = false;
        },
        handleUploaded() {
          this.$emit('uploaded')
          this.dialogVisible = false
        },
        handleClose() {
          this.dialogVisible = false
          this.$refs.upload.file_list = []
        },
      }
    }
  </script>
  
  <style>
  
    .el-dialog__body {
      padding-top: 0 !important;
    }
  
  </style>
  